import { useUser } from "../hooks/useUserQuery";

export default function isElementHiddenViaFlipper(
  flipper: { [key: string]: boolean },
  keyName: string,
): boolean {
  const user = useUser();
  const resellerUser = user?.userRoles?.find((ur: { name?: string }) =>
    ur.name?.includes("reseller"),
  );
  if (resellerUser) return false;

  return flipper[keyName] === true;
}
